import type { SingleIconProps } from "./icon"

const PenIcon = (props: SingleIconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.111 3L12.905 5.206L3 15.12V20.94L8.871 21L18.759 11.051L20.957 8.837L15.111 3ZM5 18.96V15.948L12.907 8.034L15.935 11.057L8.048 18.991L5 18.96Z"
        fill="#5E6D84"
      />
    </svg>
  )
}

export { PenIcon }
